/** @jsx h */
import { h } from 'preact';
import { FymSelectOfferCards } from './components';
import '@updater-components/loading-spinner';

const App = ({ interactor, children }) => {
  if (interactor.isHidden()) {
    return null;
  }

  const moveId = interactor.moveId;
  const loading = interactor.loading();
  const promos = interactor.getPromotions().slice(0, 4);
  const noPromos = promos.length === 0;
  const claiming = interactor.claiming();
  const source = interactor.source();
  const goToEOPage = interactor.goToEOPage;
  const togglePromoSelection = interactor.togglePromoSelection;

  return (
    <FymSelectOfferCards
      {...{
        moveId,
        promos,
        noPromos,
        claiming,
        source,
        goToEOPage,
        togglePromoSelection,
        loading,
      }}
    >
      {children}
    </FymSelectOfferCards>
  );
};

export default App;
